"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _state = require("../../../../../state");
var _Component = require("./Component");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Container = function Container() {
  var _useUser = (0, _state.useUser)(),
    user = _useUser.user;
  var _useUpdateEmail = (0, _state.useUpdateEmail)(),
    updateEmailLoading = _useUpdateEmail.updateEmailLoading,
    updateEmail = _useUpdateEmail.updateEmail;
  return /*#__PURE__*/_react.default.createElement(_Component.Component, {
    email: user.credentials.email,
    updateEmailDisabled: !!(user !== null && user !== void 0 && user.credentials.emailConfirmed),
    submitLoading: updateEmailLoading,
    onSubmit: function onSubmit(_ref) {
      var email = _ref.email;
      return updateEmail(email);
    },
    showConfirmButton: !(user !== null && user !== void 0 && user.credentials.emailConfirmed)
  });
};
exports.Container = Container;